/**
 * Simulation locale des routes IA, sans requête au fournisseur. La page garde
 * ses conditions de visibilité ; la voix reste versionnée, les coûts en cents
 * et l’aperçu une chaîne que l’écran ne doit jamais interpréter comme du HTML.
 */
import { modificationVoixIaSchema, voixIaSchema, USAGES_IA } from '@artosera/shared';
import { sessionDemo } from './demo.js';
import { ApiError } from './errors.js';
import type { Voix } from './ia.js';

let voix: Voix = { ...voixIaSchema.parse({}), version: 0, modifieLe: null, modifiePar: null };

export function reponseDemoIa(
  chemin: string,
  params: URLSearchParams,
  methode: string,
  corps?: unknown,
): unknown {
  const mois = new Intl.DateTimeFormat('fr-CA', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
  }).format(new Date());
  if (chemin === '/ia/etat') {
    const modules = sessionDemo().galeries[0]?.modules ?? [];
    return {
      disponibilite: 'active',
      usagesPermis: Object.entries(USAGES_IA)
        .filter(([, { addon }]) => addon === null || modules.includes(addon))
        .map(([usage]) => usage),
      consommation: {
        mois,
        depenseMicro: 16400000,
        depenseCents: 1640,
        reserveMicro: 0,
        plafondMicro: 20000000,
        plafondCents: 2000,
        partUtilisee: 0.82,
        seuil80Atteint: true,
      },
    };
  }
  if (chemin === '/ia/voix' && methode === 'GET') return structuredClone(voix);
  if (chemin === '/ia/voix' && methode === 'PUT') {
    const entree = modificationVoixIaSchema.parse(corps);
    if (entree.version !== voix.version)
      throw new ApiError(409, 'conflit.version', 'La voix a changé.');
    voix = {
      ...entree,
      version: voix.version + 1,
      modifieLe: new Date().toISOString(),
      modifiePar: 'compte-demo',
    };
    return structuredClone(voix);
  }
  if (chemin === '/ia/voix/apercu')
    return {
      texte:
        'Merci pour votre intérêt. Nous serons heureux de vous accueillir à la galerie. / Thank you for your interest. We look forward to welcoming you to the gallery.',
      appelId: 'demo-ia',
    };
  if (chemin === '/ia/appels')
    return { appels: [], total: 0, page: Number(params.get('page') ?? 1), parPage: 50 };
  return undefined;
}
